import * as React from 'react';
import * as I18n from 'i18n-js';
import gql from 'graphql-tag';
import {  CoreHomepagePopularProductsCspRow, reverb_search_CSPSearchRequest_Sort } from '../../../schemas/rql';
import { graphql, ChildProps } from 'react-apollo';
import CSPRow, { CSPCardFragment } from '@reverbdotcom/commons/dist/components/csp_row';

interface ExternalProps {
  title?: string;
}

type IProps = ChildProps<ExternalProps, CoreHomepagePopularProductsCspRow.Query>;

const COMPONENT_NAME = 'HomepagePopularProducts';

export function PopularProducts(props:IProps) {
  return (
    <CSPRow
      title={I18n.t('discovery.popularProductsHeading')}
      csps={props.data?.cspSearch?.csps || []}
      loading={props.data?.loading}
      trackingComponentName={COMPONENT_NAME}
      shouldTrack
    />
  );
}

const connect = graphql<ExternalProps, CoreHomepagePopularProductsCspRow.Query, CoreHomepagePopularProductsCspRow.Variables>(
  gql`
    query Core_Homepage_Popular_Products_CspRow(
      $sort: reverb_search_CSPSearchRequest_Sort
    ) {
      cspSearch(input: {
        sort: $sort,
        withInventory: true,
      }) {
        csps {
          _id
          ... CSPCard
         }
      }
    }
    ${CSPCardFragment}
  `,
  {
    options: () => {
      return {
        variables: { sort: reverb_search_CSPSearchRequest_Sort.TRENDING_DESC },
      };
    },
  },
);

export default connect(PopularProducts);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/popular_products.tsx